import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalOptions } from 'ngx-bootstrap/modal';
import { BaseComponent } from '../base-component';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { ExceptionHttp } from '../exception-http';
import { MultiplePiecesModalComponent } from '../multiple-pieces-modal/multiple-pieces-modal.component';
import { NumberConflictModalComponent } from '../number-conflict-modal/number-conflict-modal.component';
import { CategoriasGoogleAnalytics } from '../services/sesion.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent extends BaseComponent implements OnInit {
  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute) {
    super();
  }

  readonly regexExpedition = /[\t]/g;
  expeditionNumber: string;
  business = false;
  ngOnInit() {
    this.business = !!this.route.parent.routeConfig.data.business;
    if (this.business) {
      this.sesion.indiceFichaSeleccionadaCabecera$.next(1);
    }
  }

  // busqueda expedition
  async searchExpedition() {
    try {
      this.sesion.app = 'consulta';
      this.sesion.enviarEventoGoogleAnalitics(CategoriasGoogleAnalytics.ConsultaExpedicion, 'Acceso');
      this.sesion.expedition$.next(null);
      try {
        await this.sesion.searchExpedition(this.expeditionNumber);
      } catch (error) {
        const mistakeHttp = (error as ExceptionHttp);
        if (mistakeHttp && mistakeHttp.status === 409) {
          try {
            let bultos = await this.sesion.searchExpeditionByReference(this.expeditionNumber);
            if (bultos && bultos.length > 0) {
              let modalOptions = <ModalOptions<MultiplePiecesModalComponent>>{
                initialState: {
                  bultos: bultos
                }
              };
              MultiplePiecesModalComponent.show(modalOptions);
            } else {
              NumberConflictModalComponent.show();
            }
          } catch (err) {
            ErrorModalComponent.show(err);
          }
        } else {
          throw error;
        }
      }
    } catch (err) {
      ErrorModalComponent.show(err);
    }
  }


  onInitializedSharedResources() {
    this.cdr.detectChanges();
  }
}
